export default {
  RECORD_LSIT: Symbol('RECORD_LSIT'),
  GOODS_LAUNDREY_LSIT: Symbol('GOODS_LAUNDREY_LSIT'),
  UPDATE_RECORD_STATE: Symbol('UPDATE_RECORD_STATE'),
  GOODS_ROOMS_LSIT: Symbol('GOODS_ROOMS_LSIT'),
  SET_RECORD_SEARCH_VALUE: Symbol('SET_RECORD_SEARCH_VALUE'),
  SET_EXPORT_BTN_LOADING: Symbol('SET_EXPORT_BTN_LOADING'),
  ROOM_LIST: Symbol('ROOM_LIST'),
};
